// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDG3YU9wrWJZqvK_5IjvS6pF4nMEEd81m0",
  authDomain: "ecommerce-5cafd.firebaseapp.com",
  projectId: "ecommerce-5cafd",
  storageBucket: "ecommerce-5cafd.appspot.com",
  messagingSenderId: "353350713908",
  appId: "1:353350713908:web:27a9db3f286d5d3e0b8061",
  measurementId: "G-TW3XRZQMNF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export default app;